import { Section } from '../utils/sectionClassifier';
import { AnalysisResult } from '../lib/api';
import { groupStructure, structureGroupLabel, describeVibe } from '../utils/structureSummary';
import { Layers, Sparkles } from 'lucide-react';
import './SongSnapshot.css';

interface Props {
  analysis: AnalysisResult;
  sections: Section[];
  /** Optional — if provided, clicking a structure pill seeks the player there. */
  onSeek?: (timeSeconds: number) => void;
}

/**
 * Compact / Pro-tier view: a single snapshot card summarizing the whole song.
 * No per-section breakdown, no override flow. Just structure + vibe.
 */
export function SongSnapshot({ analysis, sections, onSeek }: Props) {
  const groups = groupStructure(sections);
  const vibe = describeVibe(analysis, sections);

  if (groups.length === 0) return null;

  return (
    <div className="song-snapshot">
      <div className="song-snapshot-header">
        <span className="song-snapshot-icon"><Layers size={16} strokeWidth={1.8} /></span>
        <h2 className="song-snapshot-title">Song Snapshot</h2>
      </div>

      <div className="song-snapshot-row">
        <div className="song-snapshot-row-label">Structure</div>
        <div className="song-snapshot-pills">
          {groups.map((g, i) => (
            <button
              key={i}
              type="button"
              className={`song-snapshot-pill song-snapshot-pill-${g.type}`}
              title={g.count > 1
                ? `${g.count} consecutive ${g.type} sections — click to play`
                : `${structureGroupLabel(g)} — click to play`}
              onClick={() => onSeek?.(g.startTime)}
            >
              {structureGroupLabel(g)}
            </button>
          ))}
        </div>
      </div>

      {vibe && (
        <div className="song-snapshot-row">
          <div className="song-snapshot-row-label">
            <Sparkles size={12} strokeWidth={2} /> Vibe
          </div>
          <div className="song-snapshot-vibe">{vibe}</div>
        </div>
      )}
    </div>
  );
}
